'use client';

import { useState } from 'react';

import Modal from '@/components/atoms/Modal';

import UIButton from '../atoms/UIButtons/UIButton';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

function SignupForm({ className = '', Id = '' }) {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState(null);

  /* ---------------- Email Validation ---------------- */
  const validateEmail = (value) => {
    if (!value.trim()) {
      setEmailError('Email is required');
      return false;
    }

    if (!EMAIL_REGEX.test(value.trim())) {
      setEmailError('Enter a valid email address');
      return false;
    }

    setEmailError('');
    return true;
  };

  /* ---------------- Submit ---------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(email) || loading) return;
    setLoading(true);

    try {
      const res = await fetch('/api/newsletter/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || 'Signup failed');

      setIsModalOpen(true);
      setData(data?.data || null);
      setEmail('');
      setEmailError('');
    } catch (err) {
      console.error(err);
      alert('Signup failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form
        className={`mt-4 flex h-12 w-full max-w-md items-center border border-[#5F5F5F] bg-[#464646] p-1 ${className}`}
        style={{ borderRadius: '10px 100px 100px 10px' }}
      >
        <label className="sr-only" htmlFor={Id}>
          Email
        </label>

        <input
          type="email"
          id={Id}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onBlur={() => validateEmail(email)}
          placeholder="Enter email address..."
          className="h-10 w-full min-w-0 bg-transparent xl:px-4 px-2 text-base text-white placeholder:text-white/60 focus:outline-none lg:w-[332px]"
        />

        <UIButton
          type="button"
          disabled={loading}
          className="!text-sm h-10 !text-black"
          variant="primaryTheme"
          rounded="full"
          onClick={handleSubmit}
        >
          Signup
        </UIButton>
      </form>

      {emailError && <p className="text-xs text-red-400 mt-1">{emailError}</p>}

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        {data?.message ? (
          <p className="mt-2 text-sm text-grey-400">{data.message}</p>
        ) : (
          <p className="mt-3 text-sm text-grey-400">
            Thanks for signing up! Check your inbox soon for special offers from us.
          </p>
        )}
      </Modal>
    </>
  );
}

export default SignupForm;
